import React, { useEffect, useState } from "react";
import { useLazyGetCPDEventCommiteeApprovalListQuery } from "../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { Link, useParams } from "react-router-dom";
import { decryptAESID, encryptAESID } from "../../../utils/Encryption";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import EditCommitteeCpdApproval from "../component/EditCommitteeCpdApproval";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../../components/ui/image/Image";

const CommitteeCpdAprrovalTable = () => {
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const [isModelOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [getCPDEventCommiteeApprovalList, { isSuccess: isgetCommiteeApprovalList, isLoading: isLoadinggetCommiteeApprovalList, data: getCommiteeApprovalListResponse },] = useLazyGetCPDEventCommiteeApprovalListQuery();

  useEffect(() => {
    getCPDEventCommiteeApprovalList(editID)
  }, [editID])

  useEffect(() => {
    if (!isLoadinggetCommiteeApprovalList && isgetCommiteeApprovalList && getCommiteeApprovalListResponse) {
    }
  }, [isLoadinggetCommiteeApprovalList, isgetCommiteeApprovalList, getCommiteeApprovalListResponse]);

  const handleSave = (item) => {
    setSelectedId(item.adminId)
    setIsModalOpen(!isModelOpen)
  };
  const openCloseModal = () => {
    setIsModalOpen(false);
  };


  return (
    <div className="commitee-table">
      {isgetCommiteeApprovalList && getCommiteeApprovalListResponse ? (
        <div className="tableContainer">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Decision</th>
                <th>Decision Date</th>
                <th>Comments</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {getCommiteeApprovalListResponse.map((item, index) => (
                <tr key={index}>
                  <td>{item.adminName}</td>
                  <td>{item.decision}</td>
                  <td>
                    {item.approvalDate
                      ? new Date(item.approvalDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })
                      : ''}
                  </td>
                  <td>{item.comment}</td>
                  <td>
                    <Link
                      onClick={() => handleSave(item)}
                      className="mr-3"
                      title="Edit"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <DataLoader />
      )}
      <div className='row mt-4'>
        <div className='col-lg-12'>
          {isModelOpen && (
            <CenterModel
              modelTitle={'Committee Approval'}
              show={"test"}
              handleClose={openCloseModal}
              onUpload={openCloseModal}
            >
              <EditCommitteeCpdApproval selectedId={encryptAESID(selectedId)} isModelClose={openCloseModal} getCPDEventCommiteeApprovalList={getCPDEventCommiteeApprovalList} />
            </CenterModel>
          )}
        </div>
      </div>
    </div>
  );
};
export default CommitteeCpdAprrovalTable;
